'use client'

import { init } from './init'

init()

export const InitInClient = () => {
  return null
}
